;(function (window, APP, _) {

	var FGPFacebook = function(args){
		return this.initialize(args);
	};

	_.extend(FGPFacebook.prototype, {

		initialize: function(args){

			return this;
		},

		share: function (link) {
			var winWidth = 520;
			var winHeight = 350;
			var winTop = window.screen.height / 2 - winHeight / 2;
			var winLeft = window.screen.width / 2 - winWidth / 2;
			var url = 'https://www.facebook.com/sharer/sharer.php?display=popup&method=share&u='+link

			window.open(
				url,
				"_blank",
				"top="+winTop+",left="+winLeft+",width="+winWidth+", height="+winHeight+",toolbar=0,status=0,scrollbars=no"
			);
		},

	});

	window.FGPFacebook = FGPFacebook;

}(window, window.APP, _));